export default function announcementsJs() {
	document.addEventListener("DOMContentLoaded", function (event) {
		initLoadMoreAnnouncementsButton();
	});

	const anouncementsResultsDiv = document.querySelector(
		"[data-js-announcements-results-wrapper]"
	);
	const announcementsPaginationDiv = document.querySelector(
		"[data-js-initial-announcements-pagination]"
	);
	let announcementsPagination = announcementsPaginationDiv.getAttribute(
		"data-js-initial-announcements-pagination"
	);
	let announcementsPaginationSelection = JSON.parse(announcementsPagination);

	async function getAnnouncementsHtml(pagination) {
		const announcements_endpoint = "/umbraco/surface/news/GetAnnouncements";
		let response = await fetch(announcements_endpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				culture: `${document.documentElement.lang}`,
			},
			body: JSON.stringify(pagination),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.text();
	}

	async function loadMoreAnnouncements(skip) {
		let announcementsPaginationClone = JSON.parse(
			JSON.stringify(announcementsPaginationSelection)
		);
		announcementsPaginationClone.Skip = skip;
		announcementsPaginationClone.Take = 3;

		anouncementsResultsDiv.innerHTML += await getAnnouncementsHtml(
			announcementsPaginationClone
		);
		initLoadMoreAnnouncementsButton();
	}

	function initLoadMoreAnnouncementsButton() {
		//clone and replace to remove event listeners
		const loadmoreAnouncementsBtn = document.querySelector(
			".load-more-announcements"
		);
		var new_loadmoreAnouncementsBtn = loadmoreAnouncementsBtn.cloneNode(true);
		loadmoreAnouncementsBtn.parentNode.replaceChild(
			new_loadmoreAnouncementsBtn,
			loadmoreAnouncementsBtn
		);

		//get stats from results div, to load the click event, then delete the div cause it did its job
		let announcementsResultsStatsDiv = document.querySelector(
			"[data-js-announcements-result-stats]"
		);
		const displayedAnnouncements = announcementsResultsStatsDiv.getAttribute(
			"data-js-announcements-current"
		);
		const remainingAnnouncements = announcementsResultsStatsDiv.getAttribute(
			"data-js-announcements-remaining"
		);
		announcementsResultsStatsDiv.parentElement.removeChild(
			announcementsResultsStatsDiv
		);

		//hide/show the load more if more results exist
		if (remainingAnnouncements < 1) {
			new_loadmoreAnouncementsBtn.style.display = "none";
		} else {
			new_loadmoreAnouncementsBtn.style.display = "flex";
		}

		//arm the button
		new_loadmoreAnouncementsBtn.addEventListener("click", function (e) {
			loadMoreAnnouncements(displayedAnnouncements);
		});
	}
}
